import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
var _excluded = ["className", "value", "onTabChange", "isDark", "dark", "scrollable", "backgroundColor", "full", "withGridContainer", "sticky", "size", "tabsPosition", "htmlProps", "children"];
import { Children, cloneElement, isValidElement } from 'react';
import cn from 'classnames';
import { css } from 'styled-components';
import { Container } from "../GridV2";
import parseClassnames from "../helpers/parseClassnames";
import { TABS_CLASSNAMES_BY_TAB_BUTTONS_POSITION } from "./classnames";
import { jsx as _jsx } from "react/jsx-runtime";
function Tabs(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    value = _ref.value,
    onTabChange = _ref.onTabChange,
    isDark = _ref.isDark,
    dark = _ref.dark,
    scrollable = _ref.scrollable,
    backgroundColorProp = _ref.backgroundColor,
    _ref$full = _ref.full,
    full = _ref$full === void 0 ? true : _ref$full,
    withGridContainer = _ref.withGridContainer,
    sticky = _ref.sticky,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$tabsPosition = _ref.tabsPosition,
    tabsPosition = _ref$tabsPosition === void 0 ? 'start' : _ref$tabsPosition,
    htmlProps = _ref.htmlProps,
    childrenProp = _ref.children,
    tabsProps = _objectWithoutProperties(_ref, _excluded);
  var backgroundColor = isDark || dark ? 'bg-base-dark' : 'bg-white';
  var children = Children.map(childrenProp, function (child, index) {
    if (! /*#__PURE__*/isValidElement(child)) {
      return null;
    }
    var childValue = child.props.value === undefined ? index : child.props.value;
    var selected = childValue === value;
    var onClick = function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof onTabChange === 'function') {
        onTabChange(childValue);
      }
      if (typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }
    };
    return /*#__PURE__*/cloneElement(child, _objectSpread({
      onClick: onClick,
      selected: selected,
      value: childValue,
      size: size,
      isDark: isDark || dark
    }, child.props));
  });
  var tabsWrapperClassNames = cn('inline-flex items-end', TABS_CLASSNAMES_BY_TAB_BUTTONS_POSITION[tabsPosition]);
  return /*#__PURE__*/_jsx(_StyledDiv, _objectSpread(_objectSpread(_objectSpread({
    className: parseClassnames(className, cn('inline-flex z-2 max-w-full', _defineProperty(_defineProperty({
      'w-full': full
    }, tabsWrapperClassNames, !withGridContainer), 'sticky top-0 inset-x-0 z-7', sticky), backgroundColorProp ? "bg-".concat(backgroundColorProp) : backgroundColor))
  }, htmlProps), tabsProps), {}, {
    $_css: scrollable ? 'auto' : 'hidden',
    children: withGridContainer ? /*#__PURE__*/_jsx(Container, {
      type: withGridContainer,
      className: tabsWrapperClassNames,
      children: children
    }) : children
  }));
}
export default Tabs;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-1q6jz7u-0"
})(["\n        transition: ", ";\n        overflow: ", ";\n        scrollbar-width: none; // Firefox\n        &::-webkit-scrollbar {\n          display: none; // Safari + Chrome\n        }\n      "], function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition('background-color');
}, function (p) {
  return p.$_css;
});